import { booleanAttribute, Component, input, output } from '@angular/core';
import { MultiSelectChangeEvent } from 'primeng/multiselect';
import { InputBase } from '../../../../components/input/components/base/input-base';

export interface SelectOptionWithColor {
  label: string;
  value: string;
  color?: string;
}

@Component({
  selector: 'app-button-multi-select',
  templateUrl: './button-multi-select.component.html',
  styleUrl: './button-multi-select.component.scss',
})
export class ButtonMultiSelectComponent extends InputBase {
  options = input.required<SelectOptionWithColor[]>();
  optionLabel = input.required<string>();
  optionValue = input<string>();
  filterBy = input<string>();
  showClear = input(true, { transform: booleanAttribute });

  select = output<string[]>();

  visible = false;

  toggleDropdown() {
    this.visible = !this.visible;
  }

  onSelect(event: MultiSelectChangeEvent) {
    this.writeValue(event.value);
    this.onChange(event.value);
    this.select.emit(event.value);
  }

  onClear() {
    this.writeValue([]);
    this.onChange([]);
    this.select.emit([]);
  }

  override writeValue(value: unknown): void {
    this.value = Array.isArray(value) ? value : [];
  }

  override setDisabledState(isDisabled: boolean): void {
    super.setDisabledState(isDisabled);
  }
}
